import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = {
  forgotPassword: {method: 'POST', url: 'registration/forgot'}
}

export const TokenResource = () => {
  return Vue.resource('registration', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/token.js